export default __webpack_public_path__ + "static/media/reportIcon.198512b4.svg";